import React from 'react';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import { illustrations, SvgRenderer } from 'advance-components';
import Text from '../text';
import Spacer from '../spacer';
import Button from '../button';
const StyledContainer = styled.View`
  flex-direction: column;
  justify-content: center;
  width: 296px;
`;
const CenteredTextContainer = styled.View`
  flex-direction: column;
  align-items: center;
`;
const StyledButton = styled(Button)`
  width: 100%;
`;
const StyledButtonContainer = styled.View`
  width: 100%;
`;
export default function PageHandler(props) {
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(CenteredTextContainer, null, /*#__PURE__*/React.createElement(SvgRenderer, {
    source: illustrations.Waiting,
    height: 94.88,
    width: 110
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), /*#__PURE__*/React.createElement(Text.H4, {
    style: styles.textAlignCenter
  }, props.title), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    style: styles.textAlignCenter
  }, props.body), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), /*#__PURE__*/React.createElement(StyledButtonContainer, null, /*#__PURE__*/React.createElement(StyledButton, {
    onPress: props.button.onPress
  }, props.button.label)), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), props.children));
}
const styles = {
  textAlignCenter: {
    textAlign: 'center'
  }
};
const buttonShape = {
  label: PropTypes.string,
  onPress: PropTypes.func
};
PageHandler.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  children: PropTypes.node,
  button: PropTypes.shape(buttonShape)
};
PageHandler.defaultProps = {
  title: '',
  body: '',
  button: {
    label: '',
    onPress: () => {}
  },
  children: ''
};
//# sourceMappingURL=index.js.map